import React, { useState } from "react";
import RequestService from "../../services/request.service";

import { toast } from 'react-toastify'

import moment from 'moment'
import 'moment/locale/es'



import Pagination from "../../services/Pagination";
import { Table, Form } from 'react-bootstrap'

import ModalNuevaTarea from './ModalNuevaTarea'

import ModalEditarTarea from './ModalEditarTarea'

import ModalReporteTareas from './ModalReporteTareas'


import { obtenerDiaDeLaSemana } from '../../services/funcionesPublicas'


import Dialog from '../../services/Dialogs'

const TareasSemanales = () =>{

const dialog = new Dialog();


  const [allSessionsCount,setCounter] = useState(0);
  const sessionsPerPage = 10
  const [currentPage, setCurrentPage] = useState(1);

  const [ text_busqueda, setTextoBusqueda ] = useState('')

  const [ cargando_, setCargando ] = useState( false )

  const skull = { results: [] }

  const [ tareas, setResultados ] = useState<any>({...skull})

  const cargarMiReporte = async(page:number)=>{
    try{
      setCargando(true)
      let skip = 0
      if(page===0) skip = 0; else skip = (page*10);
      let response : any = await RequestService.getEndPoint(`tareas_semanales/${arreglo_estatus}/busqueda?where=${text_busqueda}&skip=${skip}&limit=${sessionsPerPage}`)
      setCounter(response.data.totalCount)
      setResultados(response.data.resultados)
      setCargando(false)
    }
    catch(e:any){

      if (e.response?.status) {
        switch (e.response.status) {
          case 404:
            toast.error("Debes escribir algo")
            break;
          default:
            toast.error(e.response?.data)
        }
      }
      else{
        toast.error("Problemas con la busqueda")
      }
      setCargando(false)

    }
  }


  const busqueda = async () =>{
    cargarMiReporte(currentPage===0?0:currentPage-1)
    setCurrentPage(1)
  }

  const [ arreglo_estatus, setEstatus ] = useState<any>([true])


  const todos = () =>{
    setEstatus([true])
  }
  const ninguno = () =>{
    setEstatus([false])
  }


      React.useEffect(() => {
        busqueda()
      }, []);








  const [ show_ModalNuevaTarea, setModalNuevaTarea ] = useState<boolean>(false)
  const [ fecha_seleccionada, setFecha ] = useState<any>(null)
  const handleShow_ModalNuevaTarea = (fecha:any) => {
    setFecha(fecha)
    setModalNuevaTarea(true)
  }
  const handleClose_ModalNuevaTarea = () => {
        busqueda()
    setModalNuevaTarea(false)
  }


 


const [ envio_server, setSeEnvio ] = useState<boolean>(false)
const eliminarTarea = async (event:any,uuid_tarea:string) =>{

      await dialog.open({
        accept: 'Si',
        cancel: 'Espera',
        dialogClass: '',
        message: '¿Estás seguro?',
        target: event.target,
        template: `<p>La tarea será eliminada permanentemente</p>`
      })
      let dialogo : any = await dialog.waitForUser()
      if(dialogo){
        try{

        setSeEnvio(true)
        let res_ = await RequestService.delete( `tarea/eliminar/${uuid_tarea}`)

        if(res_){
          toast.warning('La tarea fue eliminada')
          setTimeout(()=>{
            busqueda()
          },0)
        }
        else{
          toast.error('Problemas...')
        } 
        }
        catch(e:any){

          if (e.response?.status) {
            switch (e.response.status) {
              default:
                toast.error(e.response?.data)
            }
          }
          else{
            toast.error("Problemas al tratar de eliminar")
          }
          setCargando(false)

        }
        
      }
     
}


  const [ show_ModalEditarTarea, setModalEditarTarea ] = useState<boolean>(false)
  const [ tarea_seleccionada, setTareaSeleccionada ] = useState<any>(null)
  const handleShow_ModalEditarTarea = (tarea:any) => {
    setTareaSeleccionada(tarea)
    setModalEditarTarea(true)
  }
  const handleClose_ModalEditarTarea = () => {
    busqueda()
    setModalEditarTarea(false)
  }


  const [ show_ModalReporteTareas, setModalReporteTareas ] = useState<boolean>(false)
  const handleShow_ModalReporteTareas = (tarea:any) => {
    setTareaSeleccionada(tarea)
    setModalReporteTareas(true)
  }
  const handleClose_ModalReporteTareas = () => {
    busqueda()
    setModalReporteTareas(false)
  }



      return (
          <>
            <div className="container-fluid contenedor">

              <h3 className="mt-3 mb-3">Tareas Semanales</h3>

              <hr/>




              <div className="row">
              
                  <div className="mb-2">
                      <label className="form-label">Búsqueda</label>
                      <div className="hstack gap-3">
                        <input className="form-control me-auto" type="text"  onKeyDown={(e)=>{if(e.keyCode === 13){ busqueda() }}} value={text_busqueda} onChange={event => setTextoBusqueda(event.target.value)} />
                        <button type="button" onClick={busqueda}  className="btn btn-secondary"><i className="fa fa-search" /></button>
                        <div className="vr"></div>
                        <button type="button" onClick={(e:any)=>{setTextoBusqueda('')}} className="btn btn-outline-danger"><i className="fa fa-trash"/></button>
                      </div>
                  </div>
                  
                <ul className="list-inline">
                  <li className="list-inline-item"><small className="pointer" onClick={()=>{handleShow_ModalNuevaTarea(null)}}>Agregar Tarea</small></li>
                </ul>

              </div>




                          {  (!cargando_) && (

                              <>

                                   {
                                     tareas.length > 0 && (

                                       <>


                                       <h5>Resultados</h5>


                                        <Table responsive="lg">
                                          <thead>
                                            <tr>
                                              <th scope="col">Fecha Límite</th>
                                              <th scope="col">Tareas</th>
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {


                                              tareas.map( (tarea:any,indice:number) =>
                                                  <tr key={indice} style={{fontSize:12}}>
                                                    <td className=" text-left" style={{"width":"260px"}}>
                                                        <h4 className="mt-4">
                                                          {
                                                            moment(tarea.fecha_limite).format('YYYY-MM-DD')
                                                          }
                                                        </h4>
                                                        <p className="nm">
                                                          {
                                                            obtenerDiaDeLaSemana(moment(tarea.fecha_limite).format('YYYY-MMM-DD'))
                                                          }
                                                        </p>
                                                    </td>
                                                    <td className="v text-left" >
                                                          <table className="table">
                                                            <thead>
                                                              <tr>
                                                                <th scope="col"></th>
                                                                <th scope="col">Tarea</th>
                                                                <th scope="col"></th>
                                                                <th scope="col"></th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                  tarea.tareas.map((tarea:any,indice_tarea:number)=>
                                                                      <React.Fragment key={indice_tarea}>
                                                                          <tr>
                                                                            <td className="v" style={{"width":"60px"}}>{indice_tarea+1}.-</td>
                                                                            <td className="v" >
                                                                              <p className="nm">{tarea.detalle_tarea}</p>
                                                                            </td>
                                                                            <td className="v" style={{"width":"40px"}}>
                                                                              <button className="btn btn-warning btn-sm" onClick={(e:any)=>{handleShow_ModalEditarTarea(tarea)}}><i className="fa fa-edit"/></button>
                                                                            </td>
                                                                            <td className="v" style={{"width":"40px"}}>
                                                                              <button className="btn btn-danger btn-sm" onClick={(e:any)=>{eliminarTarea(e,tarea.uuid)}}><i className="fa fa-trash"/></button>
                                                                            </td>
                                                                          </tr> 
                                                                      </React.Fragment>
                                                                    )
                                                                }

                                                            </tbody>
                                                          </table>
                                                        {
                                                          // JSON.stringify(tarea.tareas)
                                                        }

                                                          <ul className="list-inline">
                                                            <li className="list-inline-item"><small className="pointer" onClick={()=>{handleShow_ModalNuevaTarea(tarea.fecha_limite)}}>Agregar Tarea</small></li>
                                                            <li className="list-inline-item"><small className="pointer" onClick={()=>{handleShow_ModalReporteTareas(tarea)}}>Reporte</small></li>
                                                          </ul>

                                                    </td>
                                                  </tr>
                                               )
                                            }

                                          </tbody>
                                        </Table>


                                          <Pagination
                                            itemsCount={allSessionsCount}
                                            itemsPerPage={sessionsPerPage}
                                            currentPage={currentPage}
                                            setCurrentPage={setCurrentPage}
                                            cambiarPaginaEvento={cargarMiReporte}
                                            alwaysShown={false}
                                          />


                                        </>



                                       )
                                     
                                   }


                              </>

                           )}

                          {  cargando_ && (

                              <>
                                <div className="loader">
                                  <div className="loaderBar"></div>
                                </div>
                              </>


                           )}





            </div>




  {
    show_ModalNuevaTarea && (
      <ModalNuevaTarea show={show_ModalNuevaTarea} handleClose={handleClose_ModalNuevaTarea} fecha_limite={fecha_seleccionada}  />
      )

  }



  {
    show_ModalEditarTarea && (
      <ModalEditarTarea show={show_ModalEditarTarea} handleClose={handleClose_ModalEditarTarea} tarea={tarea_seleccionada} />
      )

  }



  {
    show_ModalReporteTareas && (
      <ModalReporteTareas show={show_ModalReporteTareas} handleClose={handleClose_ModalReporteTareas}  tarea={tarea_seleccionada}  />
      )

  }



          </>

      );
  

}

export default TareasSemanales
